import { render, staticRenderFns } from "./PreSubmissionModal.vue?vue&type=template&id=e267646a&scoped=true&lang=pug"
import script from "./PreSubmissionModal.vue?vue&type=script&lang=js"
export * from "./PreSubmissionModal.vue?vue&type=script&lang=js"
import style0 from "./PreSubmissionModal.vue?vue&type=style&index=0&id=e267646a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e267646a",
  null
  
)

export default component.exports